import React, { useEffect, useState } from "react";
import Modal from "../shared/Modal";
import "./ModalCreatePolicyProject.css";
import PolicyStudioActionButton from "./components/PolicyStudioActionButton";
import { ResourceAutocomplete } from "../common/ResourceAutocomplete";
import {
  LinkRecord,
  PolicyProjectType,
  getPolicyProjectTypeLabel,
} from "winslow-core";
import { Selector } from "../common/Selector";

interface ModalCreatePolicyProjectFromLinkRecordProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (linkRecordId: string, type: PolicyProjectType) => void;
  userId: string;
  linkRecords: LinkRecord[];
}

export const ModalCreatePolicyProjectFromLinkRecord: React.FC<
  ModalCreatePolicyProjectFromLinkRecordProps
> = ({ isOpen, onClose, onSubmit, linkRecords }) => {
  const [selectedLinkRecord, setSelectedLinkRecord] = useState<string | null>(
    null
  );
  const [selectedType, setSelectedType] = useState<PolicyProjectType | null>(
    null
  );

  const onChange = (value: string) => {
    setSelectedLinkRecord(value);
  };

  const handleSubmit = () => {
    if (selectedLinkRecord && selectedType) {
      onSubmit(selectedLinkRecord, selectedType);
      onClose();
    }
  };

  const policyProjectTypeOptions = Object.values(PolicyProjectType)
    .map((type) => ({
      value: type,
      label: getPolicyProjectTypeLabel(type),
    }))
    .sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}
      style={{
        width: "500px",
      }}>
      <div className="modal-create-policy-project">
        <div className="modal-create-policy-project-title">
          <h2>Pick a Resource</h2>
        </div>
        <div className="modal-create-policy-project-body">
          <div className="modal-create-policy-project-content">
            <ResourceAutocomplete
              resources={linkRecords || []}
              onChange={onChange}
              value={selectedLinkRecord || ""}
              placeholder="Select a resource"
            />
            <Selector
              options={policyProjectTypeOptions}
              onChange={(value: string) => {
                setSelectedType(value as PolicyProjectType);
              }}
              value={selectedType || ""}
              placeholder="Select a policy type"
            />
          </div>
        </div>
        <div className="modal-create-policy-project-buttons">
          <PolicyStudioActionButton
            label="Cancel"
            variant="primary"
            onClick={onClose}
          />
          <PolicyStudioActionButton
            label="Create"
            variant="tertiary"
            onClick={handleSubmit}
            disabled={!selectedLinkRecord || !selectedType}
          />
        </div>
      </div>
    </Modal>
  );
};
